import React, { useCallback, useEffect, useState } from "react";
import AdminShell from "../../Components/admin/AdminShell";
import { fetchAdminContactMessages } from "../../services/siteFormsApi";
import "../../Components/admin/adminDashboard.css";

function isPlaceholderDash(v) {
  const s = v == null ? "" : String(v).trim();
  return s === "" || s === "—";
}

export default function AdminMessages() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const list = await fetchAdminContactMessages();
      setRows(list);
    } catch (e) {
      setError(e?.message || "Could not load messages.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <AdminShell title="Messages" subtitle="Contact form submissions">
      {error ? (
        <div className="adminCard" style={{ padding: 14, marginBottom: 16, color: "#b91c1c", fontWeight: 600 }}>
          {error}
        </div>
      ) : null}

      <div className="adminCard">
        {loading ? (
          <div className="adminMessageList">
            {[0, 1, 2].map((i) => (
              <div key={i} className="adminMessageCard" aria-hidden="true">
                <div className="adminSkeleton" style={{ width: "45%", height: 14 }} />
                <div className="adminSkeleton" style={{ width: "100%", height: 10, marginTop: 14 }} />
                <div className="adminSkeleton" style={{ width: "72%", height: 10, marginTop: 8 }} />
              </div>
            ))}
          </div>
        ) : rows.length === 0 ? (
          <div className="adminEmpty" style={{ padding: 20 }}>
            No messages yet.
          </div>
        ) : (
          <div className="adminMessageList">
            {rows.map((r) => (
              <article key={r.id} className="adminMessageCard">
                <div className="adminMessageCardHead">
                  <h2 className="adminMessageCardName">{isPlaceholderDash(r.name) ? "—" : r.name}</h2>
                  <time className="adminMessageCardDate" dateTime={r.createdAt || undefined}>
                    {r._displayDate}
                  </time>
                </div>
                <div className="adminMessageGrid">
                  <div className="adminMessageField">
                    <span className="adminMessageFieldLabel">Email</span>
                    <div className="adminMessageFieldValue">
                      {!isPlaceholderDash(r.email) ? (
                        <a className="adminLink" href={`mailto:${r.email}`}>
                          {r.email}
                        </a>
                      ) : (
                        "—"
                      )}
                    </div>
                  </div>
                </div>
                <div className="adminMessageBlock">
                  <span className="adminMessageFieldLabel">Message</span>
                  {!isPlaceholderDash(r.message) ? (
                    <div className="adminMessageBody">{r.message}</div>
                  ) : (
                    <p className="adminMessageEmpty">No message text.</p>
                  )}
                </div>
              </article>
            ))}
          </div>
        )}
      </div>
    </AdminShell>
  );
}
